import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import App from './App'
import './index.css'

console.log('🚀 Nexus Dashboard starting...')
console.log('ENV check:', {
  supabaseUrl: import.meta.env.VITE_NEXUS_SUPABASE_URL ? 'SET' : 'MISSING',
  supabaseKey: import.meta.env.VITE_NEXUS_SUPABASE_ANON_KEY ? 'SET' : 'MISSING',
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="bottom-right"
          richColors
          closeButton
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)


